export default {
  async storeCurrentShowing({commit}, payload) {
    await fetch(process.env.VUE_APP_API_URL + "/internalapi/showing/get-showing-info/id/" + payload.id, {
      credentials: 'include'
    })
    .then((response) => {
      window.storeValidateSession(response);
      if (response.status === 500) {
        alert("Någonting gick fel. Kontakta supporten om problemet kvarstår.");
        return false;
      }
      return response.json()
    })
    .then((data) => {
      if (data.errorMessage !== null) {
        if (data.errorMessagePretty) {
          alert(data.errorMessagePretty);
        } else {
          alert("Oväntat fel. Vänligen försök igen.");
        }
        return false;
      }
      commit("STORE_CURRENT_SHOWING", data.data);
    });
  },
  // Listings for "ny visning"
  storeAllRecentListingsWithoutActiveShowing({commit,state}, force = false) {
    if ((state.allListingsWithActiveShowing !== null && state.allRecentListingsWithoutActiveShowing.length > 0) || force) {
      //placed on a new bidding object.
      fetch(process.env.VUE_APP_API_URL + '/internalapi/object-list/my-without-active-showing', {
        method: 'GET',
        credentials: 'include'
      })
      .then(response => {
        window.storeValidateSession(response);
        return response.json()
      })
      .then((data) => {
        commit("STORE_ALL_RECENT_LISTINGS_WITHOUT_ACTIVE_SHOWING", data.data);
      });
    }
  },
  // fetch and store all listings with active showing.
  storeAllListingsWithActiveShowing({commit,state}, force = false) {
    if ((state.allListingsWithActiveShowing !== null && state.allListingsWithActiveShowing.length > 0) || force) {
      fetch(process.env.VUE_APP_API_URL + '/internalapi/object-list/active-showings', {
        method: 'GET',
        credentials: 'include'
      })
      .then(response => {
        window.storeValidateSession(response);
        return response.json();
      })
      .then((data) => {
        commit("STORE_ALL_LISTINGS_WITH_ACTIVE_SHOWING", data.data);
      });
    }
  },
  // fetch and store data about the listing user has navigated to
  storeShowingDataForSelectedListing({commit}, payload) {
    const endPoint = process.env.VUE_APP_API_URL + "/internalapi/object/showing-data/id/" + payload.listingId;

    fetch(endPoint, {
      credentials: 'include'
    })
    .then(response => {
      window.storeValidateSession(response);
      return response.json()
    })
    .then((data) => {
      commit("STORE_SELECTED_LISTING_WHITH_ACTIVE_SHOWING", data.data);
    });
  },
}
